import React from 'react';
import { Tile, TileGrid } from '../../../_lib/components/Tiles';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BasicPrivilegeTicket } from '../partials/BasicPrivilegeTicket';
import { SkipLink, SkipLinkTarget } from '../../../_lib/components/SkipLink';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { TileContainerModifier } from '../../../_lib/components/Tiles/Tile';
import { TileGridModifier } from '../../../_lib/components/Tiles/TileGrid';
import { PrivilegePageType, PrivilegeType } from '../PrivilegeConfig.types';
import { translatePageType } from '../../../_lib/components/PageType/PageTypeTitle';
import { PageType } from '../../../types/api/PageType';
import { Hint } from '../../../_lib/components/Hint';
import {
  PaddingContainerDiv,
  PaddingContainerModifier,
} from '../../../components/atoms/PaddingContainer/PaddingContainer';

type PrivilegeDefaultViewProps = {
  pageTypeList: PrivilegePageType[];
  privilegeType: PrivilegeType;
};

export function BasicPrivilegeDefaultView({ pageTypeList, privilegeType }: PrivilegeDefaultViewProps) {
  const { t } = useSonTranslation('PrivilegeConfig');
  const skipLinkId = useHtmlValidId();
  const isPageRead = privilegeType === 'pageRead';

  return (
    <div className="privilege-config__basic-privilege">
      {isPageRead && (
        <PaddingContainerDiv modifier={PaddingContainerModifier.NO_PADDING_BOTTOM}>
          <Hint message={t('pageReadHint')} />
        </PaddingContainerDiv>
      )}
      <div className="privilege-config__basic-privilege-content">
        <div className="privilege-config__basic-privilege-hint font-regular-13-19">
          <p>{t(`input.${privilegeType.toLowerCase()}.description` as any)}</p>
        </div>
        <div className="privilege-config__basic-privilege-tickets">
          <SkipLink id={`skip-privilege-tickets-${skipLinkId}`}>{t('skipLinkText')}</SkipLink>
          <TileGrid modifier={TileGridModifier.TWO_COLUMNS_MAX}>
            {pageTypeList
              .sort((pageTypeA, pageTypeB) => {
                const pageTypeTitleA = translatePageType(pageTypeA.pageType as PageType);
                const pageTypeTitleB = translatePageType(pageTypeB.pageType as PageType);
                return pageTypeTitleA.localeCompare(pageTypeTitleB);
              })
              .map(pageType => (
                <Tile key={pageType.pageType} modifier={[TileContainerModifier.BOX_SHADOW, TileContainerModifier.SLIM]}>
                  <BasicPrivilegeTicket privilegePageType={pageType} />
                </Tile>
              ))}
          </TileGrid>
          <SkipLinkTarget targetName={t('skipLinkTargetText')} id={`skip-privilege-tickets-${skipLinkId}`} />
        </div>
      </div>
    </div>
  );
}
